/**
 * Semantic Z-Index Tokens
 *
 * Layering system for stacking context. Prevents ad-hoc z-index values
 * and stacking order conflicts.
 *
 * Usage:
 * - zIndex.base: Default content layer
 * - zIndex.modal: Full-screen overlays, bottom sheets
 * - zIndex.topmost: System-level alerts, toasts
 */

export const zIndex = {
  /** Behind content — backgrounds, decorative elements */
  background: -1,

  /** Default layer — normal content flow */
  base: 0,

  /** Slightly above base — cards with overlap, FABs */
  raised: 1,

  /** Card-level — overlapping card edges, badges */
  card: 2,

  /** Dropdown menus, select popups */
  dropdown: 10,

  /** Sticky headers, fixed nav bars */
  sticky: 100,

  /** Full-screen overlays, bottom sheets, modals */
  modal: 1000,

  /** Popovers on top of modals */
  popover: 1001,

  /** Tooltips — highest interactive layer */
  tooltip: 1002,

  /** System-level: toasts, alerts, debug overlays */
  topmost: 9999,
} as const;

export type ZIndex = typeof zIndex;
export type ZIndexToken = keyof ZIndex;
